import { useSelector } from 'react-redux';

import { Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { humanReadableDateWithTime } from '../../../utils';
import { SentToClientContainerStyled } from './style';

type Props = {
  jobAndProposalId: string;
};

const SentToClient = (_props: Props) => {
  const jobProcess = useSelector((state: RootState) => state.singleJobProcess);
  const reviews = jobProcess?.review || [];
  const latestReview = reviews.reduce(
    (
      latest: (typeof jobProcess)['review'][0] | null,
      current: (typeof jobProcess)['review'][0],
    ) => {
      if (
        !latest ||
        new Date(current.reviewSendDate) > new Date(latest.reviewSendDate)
      ) {
        return current;
      }
      return latest;
    },
    null,
  );

  if (!latestReview) {
    return null;
  }
  return (
    <SentToClientContainerStyled>
      <Typography strong fontColor="secondary" className="section-title">
        PDF REVIEW BY ESCAPE PLAN
      </Typography>
      <VerticalSpaceStyled $space={25}>
        <InfoRowStyled>
          <Typography className="title">Review Date :</Typography>
          <Typography className="value">
            {humanReadableDateWithTime(latestReview?.reviewDate)}
          </Typography>
        </InfoRowStyled>
        <InfoRowStyled $direction="column">
          <Typography className="title">Notes from Escape Plan :</Typography>
          <div className="value">
            <div>
              {latestReview?.reviews?.map((review) => (
                <Typography
                  key={review.substring(0, 50)}
                  style={{ marginBottom: '8px' }}
                >
                  {review}
                </Typography>
              ))}
            </div>
          </div>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </SentToClientContainerStyled>
  );
};

export default SentToClient;
